export default {"src":"/_next/static/media/triangele.5edbb321.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};